globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.TargetedCustomerProfilesSuggestions = (function(superClass) {

  utils.extend(TargetedCustomerProfilesSuggestions, superClass);

  function TargetedCustomerProfilesSuggestions() {
    return TargetedCustomerProfilesSuggestions.__super__.constructor.apply(this, arguments);
  }

  $.extend(TargetedCustomerProfilesSuggestions.prototype, {
    callbackSuccess: function(data) {
      if (data && data.response === 1) {
        window.location.reload();
      } else {
        new PNotify({ icon: "icon-cross2", title: "Une erreur est survenue", type: "error", delay: 3000 });
        this.close();
      }
    },

    callbackError: function() {
      new PNotify({ icon: "icon-cross2", title: "Une erreur est survenue", type: "error", delay: 3000 });
      this.close();
    }
  });

  return TargetedCustomerProfilesSuggestions;

})(appCustomerSpace.Modal);
